import { styled } from '@mui/system';
import { DialogTitle, Paper, Typography } from '@mui/material';

export const ModulesCtn = styled('div')(() => ({
  marginTop: 8
}));

export const ModulesTitle = styled(Typography)(() => ({
  color: '#0000008a',
  fontSize: '1rem',
  fontWeight: 400
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  color: theme.palette.getContrastText(theme.palette.secondary.main),
  backgroundColor: '#face31',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const ModuleLabel = styled('span')(() => ({
  fontWeight: 500
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  },
  height: 320,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const StyledTitle = styled(Typography)(() => ({
  textAlign: 'center'
}));
